<template>
  <v-menu
    :close-on-content-click="false"            
    transition="scale-transition"
    offset-y  
    v-model="displayPicker"
  >
    <v-text-field slot="activator" ref="colorfield" :label="label" readonly class="input-color" :value="colorValue" >
      <span slot="append" class="current-color" :style="'background-color: ' + color"  ></span>
    </v-text-field>  
    <span @dblclick="hidePicker()" class="input-group-addon color-picker-container">      
      <sketch class="picker" v-model="color" /> 
    </span>
  </v-menu>
</template>
<script>
  import { Sketch  } from 'vue-color'  
  export default {
    name: 'ColorPicker',
    components:{Sketch},
    props: {
      value:String,
      label:String
    },    
    data() {
      return {
        colorValue:'#000000',
        displayPicker: false
      }
    },            
    computed: {
      color: {
        get(){
          return this.colorValue
        },
        set(newColor){          
          this.colorValue = newColor.hex           //`rgba(${newColor.rgba.r},${newColor.rgba.g},${newColor.rgba.b},${newColor.rgba.a})`
        }
      }      
    },
    watch:{
      value(color){
        this.colorValue = color
      },   
      displayPicker(isVisible) {
          if(!isVisible) this.$emit('input', this.colorValue)   
      }
    },
    mounted(){
      this.colorValue = this.value
    },
    methods: {        
      hidePicker() {        
        this.displayPicker = false                            
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>  

.current-color {
	display: inline-block;
  position: absolute;
  right: 0px;
  top:5px;  
	width: 20px;
	height: 20px;
	cursor: pointer;
  border:1px solid #999;
}
</style>
